export function arrayToDropdownOptions(arr) {
  return arr.map((item) => {
    return {
      label: item,
      value: item,
    };
  });
}
